// extracted by mini-css-extract-plugin
export default {"create-password-wrapper":"ChangePassword_create-password-wrapper__Faw8b"};